import { useEffect } from 'react'
import { BrowserRouter } from 'react-router'

import { BetterFeatureProvider, useEnvStore } from '@di-devs/utils-fe'

import Router from './Router'
import { featureClient } from './config/client'
import 'antd/dist/reset.css'
import './assets/tailwind-generated.css'

export const App = () => {
	const { isInitialized, initialize } = useEnvStore()
	useEffect(() => {
		if (!isInitialized) {
			initialize({
				API_URL: import.meta.env.VITE_APP_API_URL || 'http://localhost:8080',
			})
		}
	}, [isInitialized, initialize])
	return (
		<BetterFeatureProvider client={featureClient}>
			<BrowserRouter>
				<Router />
			</BrowserRouter>
		</BetterFeatureProvider>
	)
}
